var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "quick-play",
      class: { "quick-play--collapsed": _vm.collapsed },
      attrs: { "aria-label": _vm.$t("Quick Play") },
    },
    [
      !_vm.collapsed
        ? _c(
            "div",
            { staticClass: "quick-play__sheet" },
            [
              _c("header", { staticClass: "quick-play__header" }, [
                _c("span", { staticClass: "quick-play__id" }, [
                  _c("em", [
                    _vm._v(
                      _vm._s(
                        _vm.table
                          ? `${_vm.table.code} #${_vm.table.round}`
                          : "--"
                      )
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "quick-play__dice" },
                  [
                    _vm.table
                      ? _c("TaiXiuDiceRow", {
                          attrs: {
                            table: _vm.table,
                            "is-rolling": _vm.isRolling,
                            "float-result": "",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "quick-play__icon quick-play__close",
                    attrs: {
                      type: "button",
                      "aria-label": _vm.$t("Close Quick Play"),
                      "aria-expanded": String(!_vm.collapsed),
                    },
                    on: {
                      click: function ($event) {
                        _vm.collapsed = true
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/quick-play-close.svg"),
                        alt: "",
                      },
                    }),
                  ]
                ),
              ]),
              _c(
                "div",
                { staticClass: "quick-play__tables" },
                [
                  _c("ArenaChips", {
                    attrs: { items: _vm.tableItems },
                    on: {
                      select: function ($event) {
                        return _vm.setQuickPlayTable($event.id)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm.table
                ? _c("TxQuickBoard", {
                    attrs: {
                      table: _vm.table,
                      "active-chip": _vm.activeChip,
                      "draft-bets": _vm.draftBets,
                      "placed-bets": _vm.placedBets,
                      "is-submitting": _vm.isSubmitting,
                      "is-rolling": _vm.isRolling,
                      "can-undo": _vm.canUndo,
                    },
                    on: {
                      bet: _vm.addBet,
                      "select-chip": _vm.selectChip,
                      undo: _vm.undoBet,
                      clear: _vm.clearBets,
                      submit: _vm.submitBets,
                    },
                  })
                : _c("p", { staticClass: "quick-play__empty" }, [
                    _vm._v(_vm._s(_vm.$t("Pick a table to start"))),
                  ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "button",
        {
          staticClass: "quick-play__bar",
          attrs: {
            type: "button",
            "aria-label": _vm.$t("Quick Play"),
            "aria-expanded": String(!_vm.collapsed),
          },
          on: {
            click: function ($event) {
              _vm.collapsed = !_vm.collapsed
            },
          },
        },
        [
          _c("img", {
            staticClass: "quick-play__bar-dice",
            attrs: {
              src: require("@/assets/images/dice-icon-active.svg"),
              alt: "",
            },
          }),
          _c("span", { staticClass: "quick-play__bar-label" }, [
            _vm._v(_vm._s(_vm.$t("Quick Play"))),
          ]),
          _c("span", { staticClass: "quick-play__bar-table" }, [
            _vm._v(_vm._s(_vm.table ? _vm.table.code : "--")),
          ]),
          _vm._m(0),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "quick-play__expand", attrs: { "aria-hidden": "true" } },
      [
        _c("img", {
          attrs: {
            src: require("@/assets/svg/tx-quickplay/chevron.svg"),
            alt: "",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }